import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Keeps the open review panel of a queue page in the URL as `?claim=<id>`.
 * Updates use replace (not push) so Back leaves the queue instead of stepping through opened claims.
 */
export function useQueueClaimParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedClaimId = searchParams.get('claim');

  const openClaim = useCallback(
    (id: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('claim', id);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const closeClaim = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete('claim');
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return { selectedClaimId, openClaim, closeClaim };
}
